import { GuestDamageItemType } from '@/services/GuestDamage/types';

export const categoryItemsMap: Record<string, string[]> = {
  'Danos de enxoval pelo hóspede': [
    'Capacho',
    'Capa edredom solteiro',
    'Capa edredom casal',
    'Capa edredom queen',
    'Capa edredom king',
    'Edredom solteiro',
    'Edredom casal',
    'Edredom queen',
    'Edredom king',
    'Fronha',
    'Enchimento de Almofada',
    'Capa de Almofada - Seazone',
    'Lençol/Virol Solteiro',
    'Lençol/Virol Casal',
    'Lençol/Virol Queen',
    'Lençol/Virol King',
    'Manta queen',
    'Manta queen inverno',
    'Pano de prato',
    'Toalha de banho',
    'Toalha de rosto',
    'Toalha de piso',
    'Toalha de maquiagem',
  ],
  'Danos de itens pelo hóspede': [
    'Mesa',
    'Cadeira',
    'Fechadura eletrônica',
    'Controles da garagem',
    'Televisão',
    'Sofá',
    'Travesseiros',
    'Cama',
    'Ar condicionado',
    'Ventilador',
    'Cabides',
    'Ferro de Passar',
    'Chuveiro',
    'Espelho',
    'Escova sanitária',
    'Secador de cabelo',
    'Lixeira',
    'Facas',
    'Garfos',
    'Colheres de sopa',
    'Colheres de chá',
    'Pratos rasos',
    'Pratos de sobremesa',
    'Copos de vidro',
    'Taças de vinho',
    'Xícaras',
    'Panelas',
    'Frigideira',
    'Escorredor de louça',
    'Colheres para cozinhar',
    'Pegador de macarrão',
    'Facas de corte',
    'Tábua de vidro ou plástico',
    'Peneira',
    'Forma de alumínio',
    'Lixeira de pia',
    'Lixeira de lixo seco',
    'Abridor de vinho e cerveja',
    'Pano de prato',
    'Jarra de Água',
    'Pá de lixo',
    'Vassoura',
    'Balde',
    'Rodo',
    'Lixeira de chão',
    'Varal',
    'Tábua de roupas',
    'Liquidificador',
    'Chaleira',
    'Sanduicheira',
    'Cafeteira',
    'Geladeira',
    'Fogão',
    'Microondas',
    'Grelha',
    'Bacia para temperar carne',
    'Tábua de madeira',
    'Garfo grande',
    'Faca para churrasco',
    'Espeto',
  ],
  Elétrico: [
    'Instalação de tomada ou interruptor',
    'Troca de disjuntor',
    'Instalação de ventilador de teto',
    'Instalação de chuveiro elétrico',
    'Verificação e conserto de curto',
    'Instalação de luminária, plafon ou lustre simples',
    'Reforma elétrica (por ponto)',
    'Instalação de fiação nova',
    'Troca de resistência de chuveiro',
    'Troca de lâmpada comum ou LED',
  ],
  Hidráulica: [
    'Desentupimento simples',
    'Troca de torneira ou sifão',
    'Conserto de vazamento',
    'Instalação de chuveirinho ou ducha higiênica',
    'Instalação de válvula de descarga ou caixa acoplada',
    "Troca de boia de caixa d'água",
  ],
  'Marcenaria e Serralheria': [
    'Conserto de porta, dobradiças e corrediças',
    'Instalação de prateleira',
    'Montagem de móveis',
    'Instalação de puxadores ou fechaduras de armário',
    'Reparo em portão ou grade',
    'Instalação de fechadura ou trinco',
    'Solda simples',
    'Instalação de braço hidráulico em porta',
    'Reparo simples em móveis (engrenagem de sofá, braço solto, etc)',
  ],
  Pintura: [
    'Pintura de ambiente (até 10 m²)',
    'Retoque de pintura, correção de manchas e descascados',
    'Pintura de porta ou janela',
    'Instalação de papel de parede (por rolo)',
  ],
  'Ar-Condicionado': [
    'Instalação de split',
    'Limpeza/Troca de Filtro',
    'Troca de controle remoto',
    'Recolocação de unidade condensadora',
    'Reparo de ar condicionado',
  ],
  Alvenaria: [
    'Reparo em reboco ou trinca',
    'Assentamento de piso/azulejo (por m²)',
    'Instalação de rodapé (por metro)',
    'Construção de mureta ou divisória pequena',
    'Reboco e nivelamento de parede (por m²)',
    'Correção de buracos em parede (massa e lixamento)',
  ],
  Vidraçaria: [
    'Troca de vidro comum',
    'Instalação de espelho (por m²)',
    'Instalação de box de banheiro',
    'Instalação de vidro temperado em janela',
    'Substituição de roldanas ou trilhos',
  ],
  'Limpeza e Conservação': [
    'Limpeza pós-obra (por ambiente)',
    "Limpeza de caixa d'água",
    'Remoção de mofo ou manchas',
    'Limpeza de janelas e vidros (por ambiente)',
    'Polimento de pisos cerâmicos ou porcelanato',
    'Limpeza de piscina',
    'Manutenção bomba piscina',
  ],
  Jardinagem: [
    'Podas simples',
    'Corte de grama',
    'Preparação de solo e plantio',
    'Remoção de folhas e limpeza de jardim',
    'Adubação e manutenção básica de plantas',
  ],
  'Fixações, instalações e suportes': [
    'Instalação de suportes (TV, micro-ondas, quadros)',
    'Fixação de cortinas ou persianas',
    'Instalação de tela de proteção em janelas',
    'Instalação de cabeceiras',
    'Instalação/manutenção de sistema a gás',
    'Troca de gás de cozinha',
  ],
  'Eletrodomésticos e Eletrônicos': [
    'Instalação de micro-ondas ou forno embutido',
    'Troca de resistência de forno ou fogão elétrico',
    'Instalação de máquina de lavar roupa ou louça',
    'Conserto de máquina de lavar (motor, bomba ou placa)',
    'Conserto de televisão',
    'Verificação e configuração de equipamentos multimídia',
    'Troca de borracha de vedação da máquina de lavar',
    'Desentupimento de mangueira de drenagem',
    'Ajuste de nível ou balanceamento da máquina',
    'Troca de filtro da máquina ou lava-louças',
    'Conserto de micro-ondas (fusível, botão, trava)',
    'Reparo em geladeira (borracha da porta, drenagem)',
    'Troca de botão, resistência ou timer de fogão',
    'Troca ou ajuste de pés niveladores (máquinas, geladeira, etc)',
  ],
  'Wi-Fi e Comunicação': [
    'Instalação ou substituição de roteador/modem',
    'Passagem de cabo de rede (por ponto)',
    'Organização e fixação de cabos',
    'Configuração de repetidor de sinal Wi-Fi',
    'Instalação de ponto de antena digital',
  ],
  'Sanitização e Dedetização': [
    'Sanitização de ambientes com ozônio ou produtos específicos',
    'Limpeza profunda de colchão ou estofado (por peça)',
    'Desinsetização preventiva',
    'Controle de pragas (cupim, baratas, formigas e insetos no geral)',
    'Higienização de ralos e pias',
  ],
  'Automação Residencial': [
    'Configuração de fechadura eletrônica com senha/app',
    'Instalação de smart lâmpadas ou interruptores inteligentes',
    'Configuração de assistente virtual (Alexa, Google Home)',
    'Configuração de câmera de segurança ou campainha inteligente',
    'Instalação de sensores de presença ou abertura',
    'Instalação de fechadura digital',
  ],
  Multa: ['Muito barulho', 'Multa Estacionamento', 'Multa Desrespeito às regras da casa', 'Outro'],
};

export const categories = Object.keys(categoryItemsMap);

export const categoryOptions = categories.map((category) => ({
  value: category,
  label: category,
}));

export const getItemOptionsByProblemType = (category: string) => {
  if (!category || !categoryItemsMap[category]) {
    return [{ value: 'other', label: 'Outro' }];
  }

  const items = categoryItemsMap[category];
  const options = items.map((item) => ({
    value: item,
    label: item,
  }));

  return options;
};

const itemClassificationMap: Record<string, GuestDamageItemType> = {
  // --- MÓVEIS ---
  Mesa: 'Móveis',
  Cadeira: 'Móveis',
  Sofá: 'Móveis',
  Cama: 'Móveis',
  'Guarda Roupa': 'Móveis',
  Balcão: 'Móveis',
  Cabides: 'Móveis',
  'Tábua de roupas': 'Móveis',
  'Tábua de madeira': 'Móveis',
  'Lixeira de chão': 'Móveis',

  // --- ELETRODOMÉSTICOS ---
  Televisão: 'Eletrodomésticos',
  TV: 'Eletrodomésticos',
  'Ar condicionado': 'Eletrodomésticos',
  Ventilador: 'Eletrodomésticos',
  'Ferro de Passar': 'Eletrodomésticos',
  'Secador de cabelo': 'Eletrodomésticos',
  Liquidificador: 'Eletrodomésticos',
  Chaleira: 'Eletrodomésticos',
  'Chaleira elétrica': 'Eletrodomésticos',
  Sanduicheira: 'Eletrodomésticos',
  Cafeteira: 'Eletrodomésticos',
  Geladeira: 'Eletrodomésticos',
  Fogão: 'Eletrodomésticos',
  Microondas: 'Eletrodomésticos',
  Torradeira: 'Eletrodomésticos',
  'Fechadura eletrônica': 'Eletrodomésticos',
  'Controles da garagem': 'Eletrodomésticos',

  // --- UTENSÍLIOS ---
  Facas: 'Utensílios',
  Garfos: 'Utensílios',
  'Colheres de sopa': 'Utensílios',
  'Colheres de chá': 'Utensílios',
  Talher: 'Utensílios',
  'Pratos rasos': 'Utensílios',
  'Pratos de sobremesa': 'Utensílios',
  Prato: 'Utensílios',
  'Copos de vidro': 'Utensílios',
  Copos: 'Utensílios',
  'Taças de vinho': 'Utensílios',
  Taça: 'Utensílios',
  Xícaras: 'Utensílios',
  Xícara: 'Utensílios',
  Panelas: 'Utensílios',
  Panela: 'Utensílios',
  Frigideira: 'Utensílios',
  'Escorredor de louça': 'Utensílios',
  'Colheres para cozinhar': 'Utensílios',
  'Pegador de macarrão': 'Utensílios',
  'Facas de corte': 'Utensílios',
  'Tábua de vidro ou plástico': 'Utensílios',
  Peneira: 'Utensílios',
  'Forma de alumínio': 'Utensílios',
  'Abridor de vinho e cerveja': 'Utensílios',
  'Jarra de Água': 'Utensílios',
  Grelha: 'Utensílios',
  'Bacia para temperar carne': 'Utensílios',
  'Garfo grande': 'Utensílios',
  'Faca para churrasco': 'Utensílios',
  Espeto: 'Utensílios',
  Chaves: 'Utensílios',
  'Lixeira de pia': 'Utensílios',
  'Pano de prato': 'Utensílios',
  Vassoura: 'Utensílios',
  Rodo: 'Utensílios',
  Balde: 'Utensílios',
  'Pá de lixo': 'Utensílios',
  Varal: 'Utensílios',

  // --- BANHEIRO ---
  Chuveiro: 'Banheiro',
  Espelho: 'Banheiro',
  'Escova sanitária': 'Banheiro',
  'Vaso sanitário': 'Banheiro',
  Torneira: 'Banheiro',
  Pia: 'Banheiro',
  Saboneteira: 'Banheiro',
  Lixeira: 'Banheiro',
};

export const classifyItemType = (itemName: string): GuestDamageItemType | undefined => {
  if (itemClassificationMap[itemName]) {
    return itemClassificationMap[itemName];
  }

  return undefined;
};
